/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

'use client';

import { c as _c } from "react/compiler-runtime";
import { ButtonLink } from '~/components/primitives';
import { cx } from 'class-variance-authority';
import Link, { type LinkProps } from 'next/link';
import { useI18n } from '~/features/i18n';
import { useTableContext } from './TableProvider';
type Props = {
  className?: string;
  /** @default false */
  isSelectable?: boolean;
  tabIndex?: number;
  children: React.ReactNode;
  actions?: React.ReactNode;
  href?: LinkProps['href'];
  /** The content of the detail button that appears when the `href` prop has been filled in.
   *
   * @default i18n._('Details') */
  detailButtonLabel?: React.ReactNode;
  mobile?: boolean;
  mobileFirstItemAsTitle?: boolean;
} & React.HTMLAttributes<HTMLTableRowElement>;
const TableRow: React.FC<Props> = t0 => {
  const $ = _c(11);
  const {
    className,
    isSelectable,
    tabIndex,
    children,
    actions,
    href,
    detailButtonLabel,
    mobile: t1,
    mobileFirstItemAsTitle: t2,
    ...props
  } = t0;
  const mobile = t1 === undefined ? true : t1;
  const mobileFirstItemAsTitle = t2 === undefined ? true : t2;
  const i18n = useI18n();
  const {
    mobileHead
  } = useTableContext();
  const t3 = "row";
  const t4 = cx("group relative table-row overflow-hidden px-4 sm:rounded-2xl", {
    "max-sm: max-sm:grid max-sm:grid-flow-dense max-sm:px-6 max-sm:py-10 grid-cols-[auto_1fr] gap-x-6 gap-y-4 sm:text-base": mobile,
    "max-sm:prose-td:col-start-2 max-sm:prose-td:p-[unset] max-sm:prose-td:text-sm": mobile,
    "max-sm:prose-th:col-start-1 max-sm:prose-th:block max-sm:prose-th:p-[unset] max-sm:prose-th:text-sm prose-th:hidden": mobile,
    "max-sm:first-of-type:prose-td:col-span-2 max-sm:first-of-type:prose-td:row-start-1 max-sm:first-of-type:prose-td:text-base first-of-type:prose-th:hidden": mobileFirstItemAsTitle && mobile
  }, props.onClick && "cursor-pointer", className);
  const t5 = mobile && mobileHead;
  let t6;
  if ($[0] !== actions || $[1] !== href || $[2] !== i18n) {
    t6 = (actions || href) && <td className="pointer-events-none absolute left-0 z-2 flex h-full w-full items-center justify-end gap-2 rounded-r-2xl py-2 opacity-0 transition group-hover:opacity-100">{href && <Link className={cx("absolute inset-0 z-0 h-full w-full", !actions && "pointer-events-auto")} aria-hidden={true} href={href} />}<div className="pointer-events-none relative z-1 ml-auto flex h-full w-full items-center justify-end pl-8 pr-4" style={{
        backgroundImage: "linear-gradient(to left,rgb(249,247,244) 0%,transparent)"
      }} onClick={_temp}><div className="pointer-events-auto flex gap-2 *:pointer-events-auto">{actions}{href && <ButtonLink variant="outline" iconAfter="arrow-right" href={href} className="relative z-1">{i18n._("Details")}</ButtonLink>}</div></div></td>;
    $[0] = actions;
    $[1] = href;
    $[2] = i18n;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== children || $[5] !== props || $[6] !== t4 || $[7] !== t5 || $[8] !== t6 || $[9] !== tabIndex) {
    t7 = <tr {...props} role={t3} className={t4} tabIndex={tabIndex}>{t5}{children}{t6}</tr>;
    $[4] = children;
    $[5] = props;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = tabIndex;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default TableRow;
function _temp(e) {
  if (e.currentTarget === e.target) {
    return;
  }
  e.stopPropagation();
}